/* eslint-disable react/forbid-component-props */
import React, { useState, useEffect } from 'react'
import { Container, Typography, Box, LinearProgress } from '@mui/material'
import { Link as NavigateLink, Link } from 'react-router-dom'
import GuideLayout from './GuideLayout'
import { useAuth } from '../../../contexts/AuthContext'
import LearningAndTheory from './Pages/LearningAndTheory'

const LearningTheory = () => {
  const [loading, setLoading] = useState(true)
  const [user, setUser] = useState(null)
  const { currentUser } = useAuth()

  useEffect(() => {
    setUser(currentUser)
    setLoading(false)
  }, [currentUser])

  return (
    <section>
      <Container fixed sx={{ marginTop: '50px' }}>
        <Typography mb={6} variant="h4">
          Training Guide
        </Typography>
        <NavigateLink to="/members">{'< Back to Members Area'}</NavigateLink>
        <Box sx={{ marginTop: 5 }}>
          {!!loading && <LinearProgress color="primary" />}
          <GuideLayout
            watermark={`Licensed to ${user?.firstName} ${user?.lastName}`}
          >
            <Box>
              <Typography align="center" mb={3}>
                PADs In Training Guide
              </Typography>
              <Typography variant="h4" align="center" mb={3}>
                Table of Contents
              </Typography>

              <Box
                component="ul"
                sx={{ pl: 3, listStyle: 'none', p: 0, m: 0, mb: 5 }}
              >
                <li style={{ listStyle: 'none', marginBottom: 10 }}>
                  <a href="#learning-theory">1. Canine Learning & Theory</a>
                </li>
                <li style={{ listStyle: 'none', marginBottom: 10, marginLeft: 20 }}>
                  <a href="#classical-conditioning">Classical Conditioning</a>
                </li>
                <li style={{ listStyle: 'none', marginBottom: 10, marginLeft: 20 }}>
                  <a href="#operant-conditioning">Operant Conditioning</a>
                </li>
                <li style={{ listStyle: 'none', marginBottom: 10, marginLeft: 20 }}>
                  <a href="#reinforcement">What is Reinforcement?</a>
                </li>
                <li style={{ listStyle: 'none', marginBottom: 10, marginLeft: 20 }}>
                  <a href="#counter-conditioning">Counter Conditioning</a>
                </li>
                <li style={{ listStyle: 'none', marginBottom: 10, marginLeft: 20 }}>
                  <a href="#adverse-methods">Adverse Training methods</a>
                </li>
                <li style={{ listStyle: 'none', marginBottom: 10, marginLeft: 20 }}>
                  <a href="#force-free">Force free training methods</a>
                </li>
                <li style={{ listStyle: 'none', marginBottom: 10, marginLeft: 20 }}>
                  <a href="#glossary">Glossary</a>
                </li>
              </Box>
            </Box>
            <LearningAndTheory />
          </GuideLayout>
        </Box>
      </Container>
    </section>
  )
}

export default LearningTheory
